window.showAdvancedReporting = function showAdvancedReporting(rollUp, cloudReport) {
  if (rollUp) {
    $('#reports_tab').hide();
  } else {
    $('#reports_tab')
      .children(':not(#reports_lstoolbox_section, #reports_advanced_reporting_section)')
      .addClass('hidden');
    $('#reports_advanced_reporting_section').removeClass('hidden');
    $('#reports_lstoolbox_section').addClass('lstoolbox-active');
  }
  const advancedReportsFrame = $('.advanced-reports-frame');
  const rollUpReport = $(`#roll-up-${rollUp}`);

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (rollUpReport.length > 0 && rollUpReport.attr('src').length === 0) {
    const source = rollUpReport.data('report');
    if (cloudReport) {
      rollUpReport.attr('src', `/AdvancedReporting/reports.php#${source}`);
    } else {
      rollUpReport.attr('src', `/lstoolbox.php?reports_redirect=${source}`);
    }
  }
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  if (!advancedReportsFrame.attr('src') || advancedReportsFrame.attr('src').length === 0) {
    if (cloudReport) {
      advancedReportsFrame.attr('src', '/AdvancedReporting/home.php');
    } else {
      advancedReportsFrame.attr('src', '/lstoolbox.php');
    }
  }

  window.resizeReportFrame(!!rollUp);
  window.responsiveReportListener(!!rollUp);
  window.showBackButton();
};

window.hideAdvancedReporting = function hideAdvancedReporting() {
  $('#reports_tab')
    .children(':not(#reports_lstoolbox_section, #reports_advanced_reporting_section)')
    .removeClass('hidden');
  $('#reports_advanced_reporting_section').addClass('hidden');
  $('#reports_lstoolbox_section').removeClass('lstoolbox-active');

  const advancedReportsFrame = $('.advanced-reports-frame');
  const rollUpReports = $('.roll-up-reports-frame');

  advancedReportsFrame.attr('src', '');
  $.each(rollUpReports, (_idx, frame) => $(frame).attr('src', ''));

  $('#reports_tab').css('padding', '');
  $('#reports_lstoolbox_section').css('padding', '');
  $('#wrapper').css('padding', '');
  $(window).off('resize');

  window.removeBackButton();
};

/**
 * Once window resizing is finished,  call the resize function to set iframe
 * dimensions to match the new window size.
 * @param {boolean} [rollUp] rollUp is an optional boolean. true if the iframe is one of the roll up reports
 */
window.responsiveReportListener = function responsiveReportListener(rollUp) {
  let resizeId: TSFixMe;
  $(window).resize(() => {
    window.clearTimeout(resizeId);
    resizeId = window.setTimeout(() => window.resizeReportFrame(rollUp), 500);
  });
};

/**
 * Use the height of the current window,  less the visible elements, to
 * dynamically change the height of the advanced reports iframe.
 * @param {boolean} [rollUp] rollUp is an optional boolean. true if the iframe is one of the roll up reports
 */
window.resizeReportFrame = function resizeReportFrame(rollUp) {
  let heightOffset;
  if (rollUp) {
    heightOffset =
      ($('footer.page').outerHeight(true) || 0) + ($('.cr-topbar').outerHeight(true) || 0);
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    $('.roll-up-reports-frame').attr('height', $(window).height() - heightOffset);
  } else {
    heightOffset =
      ($('#reports_lstoolbox_section').outerHeight(true) || 0) +
      ($('footer.page').outerHeight(true) || 0) +
      ($('.cr-topbar').outerHeight(true) || 0);
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    $('.advanced-reports-frame').attr('height', $(window).height() - heightOffset);
  }

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  const height = $(window).height() - heightOffset;
  if (navigator.userAgent.match(/iPad/i) !== null) {
    if (rollUp) {
      $('.roll-up-parent').css('height', `${height}px`);
    } else {
      $('.advanced-reports-frame').parent().css('height', `${height}px`);
    }
  }
};

window.showBackButton = function showBackButton() {
  const topbar = $('.cr-topbar');
  if (!topbar.length) {
    return;
  }

  topbar.find('#back').remove();

  const breadcrumbs = topbar.find('.cr-topbar__breadcrumbs');

  breadcrumbs.prepend(
    '<a id="back" class="cr-button cr-button--small" style="height: 24px; margin-right: 18px;" onclick="window.history.back();">' +
      '<span class="cr-button__content">' +
      '<svg class="cr-icon cr-icon-content">' +
      '<use xlink:href="#cr-icon-chevron-left" />' +
      '</svg>' +
      '</span>' +
      '</a>'
  );
};

window.removeBackButton = function removeBackButton() {
  const topbar = $('.cr-topbar');
  if (!topbar.length) {
    return;
  }

  topbar.find('#back').remove();
};
